import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { MinimalRateSchedule } from 'store/types';

// This object is specific to the Calendar Stepper, and is used to carry over the form data
// From the "Edit Rate" step into the review step. This needs to happen through context as there is
// No clear way to pass this comparison object around. It will only ever be used on the Calendar Stepper.

export const calendarEditRateInitialState: MinimalRateSchedule = {
  MIN_NIGHTS: 1,
  BASE_RATE: '',
  ID: 0,
};

const calendarEditRateSlice = createSlice({
  name: 'calendarEditRateSlice',
  initialState: calendarEditRateInitialState,
  reducers: {
    setRate: (_, { payload }: PayloadAction<MinimalRateSchedule>) => payload,
    resetRate: () => calendarEditRateInitialState,
  },
});

export const {
  reducer: calendarEditRateReducer,
  actions: { setRate, resetRate },
} = calendarEditRateSlice;
